module.exports = "/_next/static/images/cocktail-0356a938a8597741cbda9bafb25f2b92.jpg";